import { Address } from "../../../Wrap/Models/Domains/Address/Address";
import { CountryCode } from "../../../Wrap/Constants/Enums/Domain/CountryCode";
import { Email } from "./RegExPatterns";

const NAN_CHARACTERS = ["%", " "];

export function isEmpty(value: any): boolean {
    return value == null || value === "";
}

export function isNotEmpty(value: string): boolean {
    return !!value;
}

export function isNumber(value: string, culture: string): boolean {
    if (isEmpty(value)) {
        return true;
    }

    if (NAN_CHARACTERS.some((char) => value.indexOf(char) >= 0)) {
        return false;
    }

    const parsedValue: number = Globalize.parseFloat(value, 10, culture);
    const isValid = !isNaN(parsedValue) && parsedValue !== Infinity;
    return isValid;
}

export function matchesRegexp(value: string, regexp: RegExp): boolean {
    return isEmpty(value) || regexp.test(value);
}

export function isSameAs(value: string, test: string): boolean {
    return isEmpty(value) || test == null || test === value;
}

export function isEmail(value: string): boolean {
    return matchesRegexp(value, Email);
}

export function isDate(value: string, acceptDateFormats: string[]): boolean {
    if (isEmpty(value)) {
        return true;
    }

    const parsedValue: Date = Globalize.parseDate(value, acceptDateFormats, Globalize.culture().name);
    const isValid = parsedValue != null;
    return isValid;
}

export function isDateEmpty(d: number, m: number, y: number): boolean {
    return d == null && m == null && y == null;
}

export function isDateComplete(d: number, m: number, y: number): boolean {
    return d != null && m != null && y != null;
}

export function areDatePartsValid(d: number, m: number, y: number): boolean {
    const date = new Date(y, m, d);
    return d === date.getDate() && m === date.getMonth() && y === date.getFullYear();
}

export function areDate(d: number, m: number, y: number): boolean {
    return isDateEmpty(d, m, y) || (isDateComplete(d, m, y) && areDatePartsValid(d, m, y));
}

export function minLength(value: string, min: number): boolean {
    return isEmpty(value) || value.length >= min;
}

export function maxLength(value: string, max: number): boolean {
    return isEmpty(value) || value.length <= max;
}

export function isAddressPopulated(address: Address): boolean {
    if (address == null) {
        return false;
    }

    return (
        address.CountryCode !== null &&
        address.CountryCode !== CountryCode.NotSpecified &&
        isNotEmpty(address.Line1) &&
        isNotEmpty(address.Postcode) &&
        isNotEmpty(address.Line4)
    );
}
